import React from 'react'

function cards() {
  return (
    <section className='photos'>
        <div id="col-1"><h2>AMIVELTECH Private Limited’s mission is to provide reliable, innovative IT solutions that drive business growth and digital transformation.</h2></div>
        <div id="col-2"><h2>We focus on understanding client needs and delivering scalable, secure, and high-quality digital solutions using modern technologies.</h2></div>
        <div id="col-3"><h2>AMIVELTECH Pvt Ltd aims to create lasting value for clients, partners, and users while contributing to the growing technology ecosystem.</h2></div>

    </section>
  )
}

export default cards